import * as React from 'react';
import cn from 'clsx';
import { ArticleHeading1, LinkButton } from '@cian/ui-kit';

import { NBSP } from '../../constants/symbols';
import { BigHeading } from '../BigHeading';
import { withDeviceType, IWithDeviceTypeProps } from '../../utils/withDeviceType';

import * as styles from './styles.css';

const CheckDealSection: React.FC<
  React.PropsWithChildren<IWithDeviceTypeProps & { onNavigateToDealFormClick(): void; dealFormUrl: string }>
> = ({ isPhone, deviceType, isDesktop, onNavigateToDealFormClick, dealFormUrl }) => {
  const Heading = isPhone ? ArticleHeading1 : BigHeading;

  return (
    <div className={styles['container']}>
      <Heading as="h2" textAlign="center" color="white_100">
        <div className={cn(styles['heading-content'], styles[deviceType])}>
          <span>
            Ответьте на несколько вопросов {isDesktop && <br />} и{NBSP}узнайте, можно{NBSP}ли провести вашу сделку
            онлайн
          </span>
        </div>
      </Heading>
      <div className={cn(styles['button'], isPhone && styles['phone'])}>
        <LinkButton href={dealFormUrl} size="L" fullWidth onClick={onNavigateToDealFormClick}>
          Провести сделку
        </LinkButton>
      </div>
    </div>
  );
};

const CheckDealSectionWithDeviceType = withDeviceType(CheckDealSection);
export { CheckDealSectionWithDeviceType as CheckDealSection };
